/**
 * Suppress Klaviyo's legacy back-in-stock embed (enable/backinstock).
 * The theme uses the Klaviyo Client API with a custom modal instead.
 */
(function () {
  function isBackInStockEnable(item) {
    if (!Array.isArray(item)) return false;
    return item[0] === "enable" && item[1] === "backinstock";
  }

  function filterQueue(queue) {
    if (!Array.isArray(queue)) return;
    for (var i = queue.length - 1; i >= 0; i -= 1) {
      if (isBackInStockEnable(queue[i])) queue.splice(i, 1);
    }
  }

  function patchKlaviyo(klaviyo) {
    if (!klaviyo || klaviyo._bisSuppressed) return;
    klaviyo._bisSuppressed = true;

    filterQueue(klaviyo);

    var originalPush = klaviyo.push;
    if (typeof originalPush !== "function") return;

    klaviyo.push = function () {
      var args = Array.prototype.slice.call(arguments);
      if (args.length === 1 && isBackInStockEnable(args[0])) {
        return klaviyo.length;
      }
      if (isBackInStockEnable(args)) {
        return klaviyo.length;
      }
      return originalPush.apply(klaviyo, args);
    };

    if (typeof klaviyo.enable === "function") {
      var originalEnable = klaviyo.enable.bind(klaviyo);
      klaviyo.enable = function (feature) {
        if (feature === "backinstock") return;
        return originalEnable.apply(klaviyo, arguments);
      };
    }
  }

  patchKlaviyo((window.klaviyo = window.klaviyo || []));

  var attempts = 0;
  var interval = window.setInterval(function () {
    patchKlaviyo(window.klaviyo);
    filterQueue(window.klaviyo);
    attempts += 1;
    if (attempts >= 200) window.clearInterval(interval);
  }, 50);
})();
